
export {PlayListManager};

import {e, jersify} from './utils.js';
import {DataTable} from './datatable.js';
import {ytplayerState} from './ytplayer.js';
import {AnchorDot} from './glyphs.js';
import {PlayerMgr, state} from './index.js';
import {VID_PLAYLIST_URL} from './config.js';
import {PLAY_ALL_MONITOR, modifyPlayAllMonitor} from './setupmgr';


// ---------------------------
// PLAYLIST LOG ENTRY
// ---------------------------

function playlist_entry(date, pnum, pname, cat, act, rot, gnum, opp, score, created, vid, vstart, vend, active) {
	this.date       = date;
	this.playernum  = pnum;
	this.jerseynum  = jersify(pnum);
	this.playername = pname;
	this.category   = cat.substring(0, 1).toUpperCase() + cat.substring(1).replace('_', '-');
	this.action     = act;
	this.rotation   = rot;
	this.gamenum    = gnum;
	this.opponent   = opp;
	this.score      = score;
	this.created    = created;
	this.vid        = vid;
	this.vstart     = vstart;
	this.vend       = vend;
	this.vstate     = ((vid !== null) && (vstart >= 0) && (vend >= 0)) ? 2 : 0;
	this.ui_elem    = null;
	this.active     = active === undefined || active;
}



// ---------------------------
// PLAYLIST MANAGER
// ---------------------------

function PlayListManager() {

	let playAllButton;

	(function () {

		playAllButton = $("<button />").text("Play All Video Clips");
		$("#playlist_buttons").append(playAllButton);

		$(playAllButton).on("click", function () {
			f_play_all();
		});

		$("#playlist_hide_modal").easyModal();
		$("#modal_playlist_hide").on("click", function () {
			f_show_hide_playlists();
		});

	})();

	// ---------------------------
	// Properties
	// ---------------------------

	var PlayListTable = new DataTable(e("playlist_page"), "calc(100% - 67px)", true, true, this);
	var PlayListItems = [];

	// Add heads
	PlayListTable.add_head("playernum",  "int",   "",         "left",   0);
	PlayListTable.add_head("jerseynum",  "int",   "No.",      "left",   1);
	PlayListTable.add_head("playername", "str",   "Player",   "left",   3);
	PlayListTable.add_head("category",   "str",   "Category", "left",   2);
	PlayListTable.add_head("action",     "str",   "Action",   "left",   3);

	if (!state.touch) {
		PlayListTable.add_head("rotation", "int", "Rot", "center", 1);
	}

	PlayListTable.add_head("created", "date", "Date", "left", 2);

	if (state.touch) {
		PlayListTable.add_head("opponent", "str", "Event", "left", 2);
	} else {
		PlayListTable.add_head("opponent", "str", "Opponent", "left", 2);
	}

	if (state.touch) {
		PlayListTable.add_head("gamenum", "str", "Activity", "center", 2);
	} else {
		PlayListTable.add_head("gamenum", "int", "Game", "center", 1);
	}

	if (!state.touch) {
		PlayListTable.add_head("score", "score", "Score", "center", 1);
	}

	if (state.owner) {
		PlayListTable.add_head("vstate", "video",    "Video", "center", 1);
		PlayListTable.add_head("active", "checkbox", "Incl?", "center", 1);
	}


	// ---------------------------
	// Functions
	// ---------------------------

	this.load_playlist_selector = f_load_playlist_selector;
	this.row_selected           = f_row_selected;
	this.clear_table            = f_clear_table;
	this.head_checked           = f_head_checked;
	this.cell_checked           = f_cell_checked;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_load_playlist(data) {
		// Init the log
		PlayListItems = [];

		// Fill the data table
		for (let entry in data) {
			if (state.owner || data[entry].active || data[entry].active === undefined) {

				PlayListItems.push(new playlist_entry(
					data[entry].date,
					data[entry].playernum,
					data[entry].playername,
					data[entry].category,
					data[entry].action,
					data[entry].rotation,
					data[entry].gamenum,
					data[entry].opponent,
					data[entry].score,
					data[entry].created,
					data[entry].vid,
					data[entry].vstart,
					data[entry].vend,
					data[entry].active
				));
			}
		}

		PlayListTable.load_data(PlayListItems, false, false, true);
		if (state.owner) {
			PlayListTable.get_head("active").check(f_all_items_checked());
		}
	}

	// https://stackoverflow.com/questions/1634748
	function removeURLParameter(url, parameter) {
		var urlparts= url.split('?');
		if (urlparts.length>=2) {

			var prefix= encodeURIComponent(parameter)+'=';
			var pars= urlparts[1].split(/[&;]/g);

			for (var i= pars.length; i-- > 0;) {
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {
					pars.splice(i, 1);
				}
			}

			url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
			return url;
		} else {
			return url;
		}
	}

	function f_set_playlist_table(playlist_id) {
		if (PLAY_ALL_MONITOR) {
			window.clearInterval(PLAY_ALL_MONITOR);
			modifyPlayAllMonitor(null);
			PlayerMgr.stop_clip();
			$("button:contains('Stop All Video Clips')").text('Play All Video Clips');
		}

		let playlist = null;
		for (let item in state.playlists) {
			if (playlist_id === state.playlists[item].id) { playlist = state.playlists[item]; }
		}

		if (playlist) {
			f_load_playlist(playlist.data);
			if (state.owner) {
				e("playlist_url").value = removeURLParameter(window.location.href, 'playlist') + '&playlist=' + playlist_id;
				$("#playlist_url").focus(function () {
					this.select();
					this.setSelectionRange(0, 9999);
				}).mouseup(function (el) {
					el.preventDefault();
				});

			} else {
				e("guest_playlist_name").innerHTML = 'Playlist Name: <b>' + playlist.name + '</b>';
			}
			if (ytplayerState.yt_player) { ytplayerState.yt_player.stopVideo(); }
		}
	}

	function f_clear_playlist_table() {
		PlayListTable.load_data([], false, false, true);

		if (state.owner) {
			e("playlist_url").value = "";
		} else {
			e("guest_playlist_name").innerHTML = "";
		}
		if (ytplayerState.yt_player) { ytplayerState.yt_player.stopVideo(); }
	}

	function f_load_playlist_selector() {
		// Clear current options
		if (state.owner) {
			while (e("selPlayList").options.length > 0) {
				e("selPlayList").remove(0);
			}

			// Sort the playlists based on the playlist name
			state.playlists.sort( function(a, b) {
				if (a.name.toLowerCase() > b.name.toLowerCase()) {
					return 1;
				} else {
					return -1;
				}
			});

			// Load the playlists
			for (let item in state.playlists) {
				if (parseInt(e("selTeam").value) == state.playlists[item].team) {
					if (state.playlists[item].active) {
						var opt       = document.createElement('option');
						opt.value     = state.playlists[item].id;
						opt.innerHTML = state.playlists[item].name;
						if (state.playlists[item].id === state.playlistonly) {
							opt.selected = true;
						}
						e("selPlayList").add(opt);
					}
				}
			}

			if (e("selPlayList").value) {
				f_set_playlist_table(parseInt(e("selPlayList").value));
			} else {
				f_clear_playlist_table();
			}

			//Update the playlist table when changed
			e("selPlayList").onchange = function() {
				f_set_playlist_table(parseInt(e("selPlayList").value));
			};
		} else {
			f_set_playlist_table(state.playlistonly);
		}
	}

	function f_clear_table() {
		PlayListTable.clear_all_rows();
	}

	function f_row_selected(r) {
		// Play the video
		if (r.dataobj.vid === null) {
			e("novideo").style.visibility = "visible";
			e("novideo").style.display    = "block";
			PlayerMgr.pause_video();

		} else {

			e("novideo").style.visibility = "hidden";
			e("novideo").style.display    = "none";
			PlayerMgr.play_clip(r.dataobj.vid, r.dataobj.vstart, r.dataobj.vend - r.dataobj.vstart);
		}
	}

	function f_play_all() {
		if (!PLAY_ALL_MONITOR) {
			var firstRow = $('#playlist_page .data_table_rows').first().children().first()[0];

			var data = $(firstRow)[0].dataobj;
			var startRow = $(firstRow);

			if (!data.active.checked || (data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
				var nextRows = $(firstRow).nextAll();
				nextRows.each(function (index, row) {
					if (!data.active.checked || (data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
						var vstate = $(row)[0].dataobj.vstate;
						if ($(row)[0].dataobj.active.checked &&
								(vstate == AnchorDot.STATE_ANCHOR || vstate == AnchorDot.STATE_RELATIVE)) {
							data = $(row)[0].dataobj;
							startRow = $(row);
						}
					}
				});
			}

			startRow.trigger("click");

			if ((data.vid !== null) && (data.vstart >= 0) && (data.vend >= 0)) {
				$("button:contains('Play All Video Clips')").text('Stop All Video Clips');
				modifyPlayAllMonitor(window.setInterval(f_play_next, 500));
			}
		} else {
			window.clearInterval(PLAY_ALL_MONITOR);
			modifyPlayAllMonitor(null);
			PlayerMgr.stop_clip();
			$("button:contains('Stop All Video Clips')").text('Play All Video Clips');
		}
	}

	function f_play_next() {
		var currentRow = PlayListTable.get_sel_row();
		var currentRowData = $(currentRow)[0].dataobj;

		var nextRows = $(currentRow).nextAll();
		var nextRow = null;
		var nextRowData = null;
		nextRows.each(function (index, row) {
			if (nextRowData === null) {
				let vstate = $(row)[0].dataobj.vstate;
				if (
					($(row)[0].dataobj.active.checked || $(row)[0].dataobj.active === true) &&
					(vstate == AnchorDot.STATE_ANCHOR || vstate == AnchorDot.STATE_RELATIVE)
				) {
					nextRow = row;
					nextRowData = $(row)[0].dataobj;
				}
			}
		});

		var currentTime = ytplayerState.yt_player.getCurrentTime();

		if (nextRow && nextRowData) {
			if (currentTime >= currentRowData.vend || (nextRowData.vstart > currentRowData.vstart && currentTime >= nextRowData.vstart)) {
				$(nextRow).trigger("click");
			}

		} else if (currentTime >= currentRowData.vend) {
			window.clearInterval(PLAY_ALL_MONITOR);
			modifyPlayAllMonitor(null);
			PlayerMgr.pause_clip();
			$("button:contains('Stop All Video Clips')").text('Play All Video Clips');
		}
	}

	function f_show_hide_playlists() {
		// Clear current options
		if (state.owner) {
			$("#playlist_hide_list").empty();

			for (let item in state.playlists) {
				let checkbox =
					"<input type=checkbox " +
					(state.playlists[item].active ? "checked " : "") +
					"class='hidden_playlist_checkbox' data-playlist_id='" +
					state.playlists[item].id +
					"' style='margin-top: 2px;'" +
					state.playlists[item].name +
					"/>&nbsp;&nbsp;" +
					state.playlists[item].name;
				$("#playlist_hide_list").append("<li>" + checkbox + "</li>");
			}
		}

		$('#playlist_hide_modal').trigger('openModal');

		$('#playlist_hide_modal_cancel').off('click').click(function(){
			$('#playlist_hide_modal').trigger('closeModal');
		});

		const getHiddenPlaylistIds = () => {
			let ids = [];
			$(".hidden_playlist_checkbox").each(function () {
				if (!$(this).is(":checked")) {
					ids.push(parseInt($(this).attr("data-playlist_id"), 10));
				}
			});
			return ids;
		};

		const getVisiblePlaylistIds = () => {
			let ids = [];
			$(".hidden_playlist_checkbox").each(function () {
				if ($(this).is(":checked")) {
					ids.push(parseInt($(this).attr("data-playlist_id"), 10));
				}
			});
			return ids;
		};

		$('#playlist_hide_modal_save').off('click').click(function(){
			let hidden_playlist_ids = getHiddenPlaylistIds();

			let payload = {
				uid: state.solouid,
				version: '2',
				h_playlists : hidden_playlist_ids.join(),
				v_playlists : getVisiblePlaylistIds().join(),
			};

			return $.ajax({
				url: "/solo/put/settings",
				type: "post",
				data: payload,
				dataType: "json",
			})
				.then((rsp) => {
					// set all to active
					for (let item in state.playlists) {
						state.playlists[item].active = true;
					}
					// unset the hidden ones
					for (let id in rsp.hidden_playlists) {
						for (let item in state.playlists) {
							if (id == state.playlists[item].id) {
								state.playlists[item].active = false;
							}
						}
					}
					f_load_playlist_selector();
					$('#playlist_hide_modal').trigger('closeModal');
				});

		});
	}

	function f_save_filtered_playlist() {
		var data = PlayListTable.export_detailed_rows();

		var i, len;
		for (i=0, len=data.length; i < len; i++) {
			data[i].active = PlayListItems[i].active.checked;
		}

		var pkg = {
			uid: state.solouid,
			tid: e("selTeam").value,
			data: JSON.stringify(data),
			update: e("selPlayList").value
		};

		$.ajax({
			type: 'POST',
			url: VID_PLAYLIST_URL,
			data: pkg,
			context: this
		})
			.then(function(){
				var playlist_id = parseInt(e("selPlayList").value);
				for (var item in state.playlists) {
					if (playlist_id === state.playlists[item].id) {
						state.playlists[item].data = data;
					}
				}
			})
			.catch(function(){
				alert('Unable to update playlist. Please try again later.');
			});
	}


	// ---------------------------
	// Selection Methods
	// ---------------------------

	function f_check_all_items(tf) {
		for (var i = 0; i < PlayListItems.length; i++) {
			PlayListItems[i].active.checked = tf;
		}
	}


	// ---------------------------
	// Retrieval Methods
	// ---------------------------

	function f_all_items_checked() {

		for (var i = 0; i < PlayListItems.length; i++) {
			if (! PlayListItems[i].active.checked) {
				return false;
			}
		}

		return true;
	}


	// ---------------------------
	// Events
	// ---------------------------

	function f_head_checked(prop, checked) {
		if (state.owner && prop == "active") {
			f_check_all_items(checked);
			f_save_filtered_playlist();
		}
	}

	function f_cell_checked(item, prop) {
		if (state.owner && prop == "active") {
			f_save_filtered_playlist();

			if (item[prop].checked) {
				PlayListTable.get_head("active").check(f_all_items_checked());
			} else {
				PlayListTable.get_head("active").check(false);
			}
		}
	}

}

